var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"scale"}},[_c('div',{staticClass:"profile-icon-root",style:({
      backgroundImage: ("url(" + _vm.iconSrc + ")"),
      border: _vm.border,
      width: (_vm.size + "px"),
      height: (_vm.size + "px")
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }